import React from "react";

function Projects() {
  return (
    <div className="font-sans">

      {/* First Section: Projects */}
      <section className="bg-red-800 py-5 px-8">
        <div className="max-w-screen-xl mx-auto text-center text-white">
          <h2 className="text-2xl md:text-4xl font-bold mb-4">Every Project Tells a Story.</h2>
          <p className="text-xl mb-5">
            We design for every scale and ambition: Corporate & IT Offices, Hospitality & Experience Centers, and more.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            <img src="/images/projects/first.png" alt="Project 1" className="w-full h-72 rounded-lg object-cover" />
            <img src="/images/projects/second.jpg" alt="Project 2" className="w-full h-72 rounded-lg object-cover" />
            <img src="/images/projects/third.jpg" alt="Project 3" className="w-full h-72 rounded-lg object-cover" />

            <img src="/images/projects/fourth.png" alt="Project 4" className="w-full h-72 rounded-lg object-cover" />
            <img src="/images/projects/fifth.png" alt="Project 6" className="w-full h-72 rounded-lg object-cover" />
            <img src="/images/projects/sixth.png" alt="Project 5" className="w-full h-72 rounded-lg object-cover" />
          </div>
        </div>
      </section>

      {/* Second Section: Stats and Awards */}
      <section className="pt-6 px-8 bg-gray-100">
        <div className="max-w-screen-xl mx-auto text-center">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 mb-16">
            <div className="space-y-4 bg-red-700 p-5 rounded-lg">
              <div className="text-5xl font-bold text-white">17</div>
              <div className="text-lg text-white">Years of Market Presence</div>
            </div>
            <div className="space-y-4 bg-red-700 p-5 rounded-lg">
              <div className="text-5xl font-bold text-white">60+</div>
              <div className="text-lg text-white">Projects Delivered</div>
            </div>
            <div className="space-y-4 bg-red-700 p-5 rounded-lg">
              <div className="text-5xl font-bold text-white">45+</div>
              <div className="text-lg text-white">Turnkey Projects</div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Projects;
